module.exports = __webpack_public_path__ + "5ca4ccfcec8052ce7aff71b14544baf9.png";